export default class FacetDrawer extends window.HTMLElement {
  dialog: HTMLDialogElement | null = null;
  overlay: HTMLDivElement | null = null;
  panel: HTMLDivElement | null = null;

  constructor() {
    super();
    this.dialog = this.querySelector('dialog');
    this.overlay = this.querySelector('#facet-drawer-overlay');
    this.panel = this.querySelector('#facet-drawer-panel');
    const closeBtns = this.querySelectorAll('[data-facet-drawer-close]');

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.close();
      });
    });

    this.overlay?.addEventListener('click', () => {
      this.close();
    });

    // Intercept native Escape close
    this.dialog?.addEventListener('cancel', (e) => {
      e.preventDefault(); // stop auto-close
      this.close(); // use animated version
    });
  }

  show() {
    window.scrollLock();
    this.dialog?.showModal();
    this.panel?.classList.remove('translate-x-full');
    this.panel?.classList.add('translate-x-0');
  }

  close() {
    window.scrollUnlock();
    this.panel?.classList.remove('translate-x-0');
    this.panel?.classList.add('translate-x-full');

    setTimeout(() => {
      this.dialog?.close();
    }, 300);
  }
}

if (!customElements.get('facet-drawer')) {
  window.customElements.define('facet-drawer', FacetDrawer);
}
